import { render, staticRenderFns } from "./CreateImport.vue?vue&type=template&id=e0e38e32&scoped=true"
import script from "./CreateImport.vue?vue&type=script&lang=js"
export * from "./CreateImport.vue?vue&type=script&lang=js"
import style0 from "./CreateImport.vue?vue&type=style&index=0&id=e0e38e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e38e32",
  null
  
)

export default component.exports